export default __webpack_public_path__ + "static/media/$100.0f6e9109.png";